const authConfig = {
  clientId: "0oa19iohkQYKhTtEg4x6",
  url: "https://dev-534680.okta.com/",
  tokenManager: {
    storage: "memory",
    secure: true,
  },
  pkce: true,
};

export default authConfig;
